"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtExtractorService = void 0;
var JwtExtractorService = /** @class */ (function () {
    function JwtExtractorService() {
    }
    JwtExtractorService.prototype.getTokenFromAttribute = function (data, attrName) {
        var jwtToken;
        try {
            jwtToken = JSON.parse(data)[attrName];
        }
        catch (e) {
            console.error(e);
            throw new Error("Cannot extract token from ".concat(data, " with attribute ").concat(attrName));
        }
        return jwtToken;
    };
    JwtExtractorService.prototype.extract = function (tokenName, tokenAttr) {
        var jwtToken;
        var token = localStorage.getItem(tokenName);
        if (token) {
            jwtToken = !tokenAttr ? token : this.getTokenFromAttribute(token, tokenAttr);
        }
        return jwtToken;
    };
    return JwtExtractorService;
}());
exports.JwtExtractorService = JwtExtractorService;
